<template>
<div>
  <div class="flex-wrap" :class="`priority-${itemData.priority}`" @click="handleClickRow">
    <div class="red-point-wrap ">
      <img v-if="msgType === 1" class="notification" src="@/assets/push-msg-icon.svg" style="margin-top: -2px;"/>
      <img v-else class="notification" src="@/assets/push-todo-icon.svg" />
    </div>
    <div style="flex: 1">
      <div class="title-wrap">
        <div class="item-title" :title="isZh ? itemData.titleCn : itemData.title">
          {{ isZh ? itemData.titleCn : itemData.title }}
        </div>
        <div class="item-dur">
          {{ itemData.dur }}
        </div>
      </div>
      <div class="item-content" :title="isZh ? itemData.contentCn : itemData.content">
        {{ isZh ? itemData.contentCn : itemData.content }}
      </div>
      
    </div>
  </div>

  <lls-dialog
    :visible.sync="dialogVisible"
    width="640px"
    :append-to-body="true"
    class="detail-dialog"
    @close="handleDialogClose"
  >
   <Detail 
    :itemData="itemDataDatail" 
    :msgType="msgType" 
    @handleMarkDone="handleMarkDone"
    ></Detail>
  </lls-dialog>

</div>
</template>

<script>
import { filterDictParam } from '@/common/util.js'
import Detail from './Detail.vue';

export default {
  props: {
    itemData: {
      type: Object,
      default: () => {}
    },
    msgType: { // 1-Message 2-todo
      default: 0,
      type: Number
    },
    isZh: { 
      default: false,
      type: Boolean
    }
  },
  components: {
    Detail
  },
  data() {
    return {
      dialogVisible: false
    }
  },
  computed: {
    itemDataDatail() {
      if (this.isZh) {
        return {
          ...this.itemData,
          title: this.itemData.titleCn,
          content: this.itemData.contentCn
        }
      } else {
        return {
          ...this.itemData
        }
      }
    }
  },
  methods: {
    handleClickRow () {
      this.dialogVisible = true
      
    },
    handleDialogClose () {
      // 弹窗消失之前 设置消息已读
      if (this.msgType === 1) { // message 点击就是已读
        // 读，全部读or办理   1:已读  2:已全部读  3:已办理
        this.fetchMarkedMsg(this.itemData.id, 1)
      }
    },
     // 处理 to do
     async handleMarkDone(currentRow) {
      // 读，全部读or办理   1:已读 2:已全部读 3:已办理
      const flag = await this.fetchMarkedMsg(currentRow.id, 3)
      if (flag) {
        this.dialogVisible = false
      }
    },
    async fetchMarkedMsg(id, updType) {
      let params = {
        id,
        updType // 读，全部读or办理   1:已读 2:已全部读 3:已办理
      }
      // 自行处理错误信息
      try {
        const data = await this.$API.system.updateHandleStatus(params)

        var code = data.data.code;
        if (code == "200") {
          this.$emit('refreshCount') // 更新待办数量
          // 点击单行不提示成功
          if (updType !== 1) {
            this.$message({
              type: 'success',
              message: 'success',
              customClass: 'custom-message',
            });
          }
  
          return true
        }
      } catch (err) {
        this.$message({
          type: 'error',
          message: err,
          customClass: 'custom-message',
        });
      }
    },
  },
  mounted() {
  }
}
</script>

<style scoped lang="scss">
.flex-wrap {
  position: relative;
  display: flex;
  padding: 16px 24px;
  gap: 18px;
  color: #4A4A4A;
  line-height: 18px;
  border-bottom: 1px solid #E2E8F0;
  cursor: pointer;
  margin-top: -23px;
  margin-left: -27px;
  margin-bottom: -15px;
  margin-right: -34px;
  width: 380px;

  &::before{
    content: '';
    background-color: #fff;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 8px;
  }
}
.red-point-wrap {
  flex: 0 0 6px;
}
.red-point {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  display: inline-block;
}
.item-title {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: left;
}
.item-content {
  font-size: 14px;
  line-height: 20px;
  color: #4A4A4ACC;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-all;
}
.item-dur {
  font-size: 12px;
  white-space: nowrap;
  padding-right: 15px;
}
.item-ops {
  margin-top: 12px;
}
.title-wrap{
  display: flex; 
  justify-content: space-between; 
  gap: 10px
}
.priority-1 {
  // background: #F76C5E0D;
  &::before{
    content: '';
    background-color: rgba(247, 108, 94, 0.2);
  }
  .red-point {
    background-color: #F76C5E;
  }
}
.priority-2,.priority-3 {
  // background: #5A9CF80D;
  &::before{
    content: '';
    background-color: rgb(90 156 248 / 20%);
  }
  .red-point {
    background-color: #4E78B1 ;
  }
}

.detail-dialog  {
  display: flex;
  align-items: center;
  ::v-deep {
    .lls-dialog {
      margin: 0 auto !important;
    }
  }
}
</style>

